ul {
  @include font(light);
  color: $color-grey-text-light;
  line-height: 1.6;
  list-style-type: none;
  padding: 0;

  :host([variant='square']) & {
    --variant: square;
  }
}
